import Tag from './Tag';

export class SearchQuery {
  constructor(public tags: Array<Tag> = []) {}

  public isEmpty(): boolean {
    if (this.tags.length) {
      return false;
    }

    return true;
  }
}



// WEBPACK FOOTER //
// ./src/app/models/SearchQuery.ts